import { Modal } from 'antd';
import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';

export const Container = styled.div`
  margin-left: 64px;
  padding: 0px 16px;
`;

export const Header = styled.div`
  display: flex;
  width: 380px;
  justify-content: space-between;
`;

export const SectionTitle = styled.p``;

export const DepositsTotalizerValue = styled.p<{ isNegativeValue: boolean }>`
  margin: 0;
  color: ${({ isNegativeValue }) => (isNegativeValue ? COLORS.red : COLORS.black)};
`;

export const DepositContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${COLORS.white};
  border-radius: 8px;
  box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.1);
  padding: 12px;
  margin-top: 8px;
  align-items: center;
  border: 0.5 0.5 0.5 0.5px #d9d9d9;

  p {
    margin: 0;
  }
`;

export const DepositList = styled.div`
  overflow-y: scroll;
  max-height: 217px;
  padding-right: 8;
  padding-bottom: 8;
`;

export const DepositDate = styled.p``;

export const DepositType = styled.p``;

export const DepositValue = styled.p<{ color: string }>`
  color: ${({ color }) => color};
`;

export const SaldoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EditBalanceButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;

  &:hover svg path {
    fill: ${COLORS.black};
  }
`;

export const ManualAdjustmentModalStyled: any = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-header {
    border-bottom: none;
    padding-bottom: 4px;
  }

  .ant-modal-title {
    font-size: 20px;
    font-weight: normal;
    color: black;
  }

  .ant-modal-body {
    padding-top: 12px;
  }

  .ant-modal-footer {
    border-top: none;
    padding: 8px 24px 24px;
  }

  .ant-input {
    height: 44px;
    border-radius: 8px;
  }

  .ant-radio {
    transform: scale(1.25);
    margin-top: 3px;
  }

  .ant-modal-footer .ant-btn {
    height: 40px;
    padding: 0 22px;
    border-radius: 8px;
  }
`;

export const FieldLabel = styled.p`
  margin: 0 0 8px;
  color: ${COLORS.black};
`;

export const OptionText = styled.span`
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
`;

export const OptionTitle = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${COLORS.black};
`;

export const OptionDescription = styled.span`
  font-size: 13px;
  color: ${COLORS.lightDarkText};
`;
